import {LeaderboardRowData} from '../../../../shared/leaderboard_data/LeaderboardInterfaces'
import {createTDIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {UIDLeaderboardBaseTableRowView} from './UIDLeaderboardBaseTableRowView'

export class UIDLeaderboardTableRowViewRanked extends UIDLeaderboardBaseTableRowView {
    readonly tdMMR: HTMLTableCellElement
    readonly tdWinRate: HTMLTableCellElement
    readonly tdTotalGamesPlayed: HTMLTableCellElement

    constructor(container: HTMLElement, rowData: LeaderboardRowData, index: number, onLeaderboardUrlChange: (leaderboardUrl: string) => void) {
        super(container, rowData, index, onLeaderboardUrlChange)

        const tableRowID = rowData.myData ? 'my_leaderboard_cell' : 'leaderboard_cell'

        this.tdMMR = createTDIn(this.tableRow, tableRowID)
        this.tdWinRate = createTDIn(this.tableRow, `${tableRowID} hide_on_narrow_screens`)
        this.tdTotalGamesPlayed = createTDIn(this.tableRow, `${tableRowID} hide_on_narrow_screens`)

        this.update(rowData)

        if(rowData.myData) this.setMyFlagIcon(rowData)
    }

    update(rowData: LeaderboardRowData) {
        super.update(rowData)

        this.tdMMR.innerText = String(rowData.skillRating)
        this.tdWinRate.innerText = `${rowData.winRate.toFixed(1)}%`
        this.tdTotalGamesPlayed.innerText = '' + rowData.totalGamesPlayed
    }
}
